import { Tab } from "@chakra-ui/react";
import {
  usePageTabs,
  UsePageTabsProps,
} from "shared/components/layout/PageTabs";
import { TableBoxTabs } from "shared/components/table/box/TableBoxTabs";

export const TableBoxPageTabs: React.FC<UsePageTabsProps> = (props) => {
  const { tabs, tabsProps } = usePageTabs(props);
  return (
    <TableBoxTabs {...tabsProps}>
      {tabs.map((tab, index) => (
        <Tab key={index}>{tab.title}</Tab>
      ))}
    </TableBoxTabs>
  );
};
